import { IInventoryPage } from '../../../inventory-page.interface';


export const RESEARCH_RESEARCH_BEST_SELLERS_PAGE: IInventoryPage = {
	'route': '/research/research/best-sellers',
	'title': 'Best Sellers',
	'uiReference': [
		'Search Best Sellers',
		'Open in Amazon',
		'Open search options',
		'Exclude Words',
		'Toggle BSR range filter',
		'Toggle price range filter',
		'Market distribution',
		'Sorting and filters are available in the paid version',
		'Search',
		'Search options',
		'Choose how results should be matched.',
		'Specific search Prioritize an exact keyword match.',
		'Title only Limit matches to listing titles.',
		'Marketplace',
		'Product',
		'Sorting',
		'Advanced Options',
		'Advanced filters',
		'Reset filters',
		'Excludes',
		'Options',
		'Hide official brands',
		'Subcategories',
		'BSR range',
		'Rating',
		'Price range',
		'Date range',
		'Keyword intelligence',
		'Understand how shoppers search',
		'Add keywords to the Keyword Board, or open one to filter the design carousel.',
		'Design comparison',
		'Choose designs to compare',
		'Select up to three leading designs for a side-by-side performance review.',
		'of 3 selected',
		'Loading...',
		'BSR',
		'Review',
		'Price',
		'Newest',
		'Oldest',
		'Random',
		'Copy all ASINs',
		'ASIN Board',
		'Copy All ASINS',
		'Demand history time range',
		'Latest observed demand',
		'/ month',
		'Same month last year',
		'n/a',
		'Peak vs prior year',
		'% vs',
		'Usable history',
		'months',
		'observed months · Latest: (/ designs)',
		'Monthly median estimated sales for the currently loaded designs; the shaded range is the middle 50%. Dots are observed months; dashed connectors cross months without enough observations.',
		'Typical demand now',
		'Stronger quarter',
		'Designs with demand',
		'Ranked coverage',
		'/ designs',
		'Current snapshot',
		"Only comparable month(s); showing demand across today's ranked results",
		'No ranked designs in the loaded results',
		'Load more results or adjust the search filters to calculate current demand.',
		'Current ranked designs sorted from strongest to weakest estimated monthly demand. This is a snapshot, not a historical trend.',
		'Sales',
		'Compare historical performance and listing characteristics.',
		'Preparing design comparison',
		'Design',
		'(ASIN: )',
		'Performance',
		'&pound;',
		'&euro;',
		'Remove from favorites',
		'Enter a tag',
		'Favorite tag',
		'Generate image using AI',
		'NEW',
		'History Rank :',
		'History Price : NA',
		'Removed',
		'ASIN',
		'review(s)',
		'Published since',
		'Saved',
		'Update tag',
		'Show BSR categories',
		'Show estimated sales history',
		'Show price history',
		'Open design details',
		'Platform:',
		'Category:',
		'ASIN :',
		'N/A',
		'Reviews',
		'Bulletpoints and Description',
		'View design',
		'Sorry, there was an internal error. Please contact support.',
		'Oh man, the board seems to be not included in the free version',
		'Open in KW Workbench',
		'Copy to Clipboard'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/research-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/best-sellers/best-sellers.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/best-sellers/best-sellers.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/best-sellers/best-sellers.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/research-results-toolbar/research-results-toolbar.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/research-results-toolbar/research-results-toolbar.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-views/mba-design-view/mba-design-view.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-views/mba-design-view/mba-design-view.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/statistics/bsr-seller-rank/bsr-seller-rank.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/statistics/bsr-seller-rank/bsr-seller-rank.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/statistics/bsr-seller-rank/bsr-seller-rank.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/statistics/charts/distributions/distributions.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/statistics/charts/distributions/distributions.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/preview/word-frequency-keyword/word-frequency-keyword.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/preview/word-frequency-keyword/word-frequency-keyword.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/suggestions/suggestions.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/suggestions/suggestions.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/design-carousel/design-carousel.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/design-carousel/design-carousel.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/compare-designs/compare-designs.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/compare-designs/compare-designs.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba/design-mba.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba/design-mba.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba-detail/design-mba-detail.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba-detail/design-mba-detail.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-board/kw-board.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-board/kw-board.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/chart/chart.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/chart/chart.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/trends-badge/trends-badge.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/trends-badge/trends-badge.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/add-to-favorite/add-to-favorite.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/add-to-favorite/add-to-favorite.component.html'
	],
	'aliases': []
};
